import { Modal } from 'antd';
import styled from 'styled-components';

export const ModalStyled = styled(Modal)`
  & .ant-modal-footer {
    display: flex;
    justify-content: space-between;
  }
`;
